export default "/images/1be90c6aa126ab673afec793e792463d.avif";